import * as yup from "yup";

const ConsultantRegistrationSchema = yup.object().shape({
    name: yup
        .string()
        .required('Please Enter Name'),
    email: yup
        .string()
        .email("Please enter a valid email!")
        .required("Please Enter Email"),
    password: yup
        .string()
        .min(8, "Password must be longer than 8 characters")
        .required("Password is required"),        
    phone: yup
        .string()
        .matches(/^[0-9]+$/, "Phone number can only contain digits")
        .transform((value) => value.replace(/[^0-9]/g, ''))
        .length(10, 'Phone must be exactly 10 digits')
        .required('Please Enter Phone Number'),
    termsAndConditions: yup
        .boolean()
        .required('Must agree to Terms And Conditions')
        .oneOf([true], "Must agree to Terms And Conditions"),
});

export default ConsultantRegistrationSchema;